module.exports = __webpack_public_path__ + "static/img/b1.6108c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b1.jpg
// module id = PPFf
// module chunks = 1